export const CosmosModels = {
  TELCO: 'telco',
  BANK: 'bank',
} as const;

type CosmosModelsKeys = keyof typeof CosmosModels;
export type CosmosModelsType = typeof CosmosModels[CosmosModelsKeys];

export default CosmosModels;
